import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cartLogo from '../../assets/img/empty-cart.svg';
import Button from '../../Components/Button/Button';
import ProductCard from '../../Components/ProductCard/ProductCard';
import { CartContext } from '../../Context/CartContext/CartContext';
import CartDescription from './CartDescription';
import styles from './CartPage.module.scss';

const CartPage = () => {
  const { state: { cartItems } } = useContext(CartContext);
  return (
    <div className={styles.cartPageContainer}>
      {cartItems.length > 0
        ? (
          <>
            <div className={styles.title}>Your Cart</div>
            <div>
              {cartItems.map(({ product, quantity }, index) => (
                <div key={product.id}>
                  <ProductCard
                    id={product.id}
                    imageUrl={product.image}
                    description={(
                      <CartDescription
                        title={product.title}
                        quantity={quantity}
                        index={index}
                      />
                    )}
                    tailing={`₹ ${quantity * (parseFloat(product.price))}`}
                    shadow={false}
                  />
                </div>
              ))}
            </div>
            <Link to="/checkout" className={styles.linkStyle}>
              <Button width="15vw">Proceed</Button>
            </Link>
          </>
        ) : (
          <div className={styles.emptyContainer}>
            <Link to="/" className={styles.linkStyle}>
              <object data={cartLogo} type="image/svg+xml" className={styles.cartLogo}>
                Empty cart
              </object>
              <h2>There is nothing in your cart, click here to explore our products</h2>
            </Link>
          </div>
        )}
    </div>
  );
};

export default CartPage;
